import { Component } from '@angular/core';
import { getGamificationProfileAction } from '../../shared/actions/gamification.actions';
import { Store } from '@ngrx/store';
import { AppState } from '../../shared/reducers/index.tx';
import { GamificationService } from '../../shared/gamification.service';

@Component({
  selector: 'lp2-leaderboard-error',
  templateUrl: './leaderboard-error.component.html',
  styleUrls: ['./leaderboard-error.component.scss'],
})
export class LeaderboardErrorComponent {
  constructor(
    private store: Store<AppState>,
    private gamificationService: GamificationService
  ) {}

  tryAgain(): void {
    this.store.dispatch(getGamificationProfileAction());
    this.gamificationService.startRefreshGamification();
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/leaderboard-error/leaderboard-error.component.ts